var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 345.9655 94.798",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "logotype_match",
    d: "M9.3899.9004h27.3555c5.1859,0,9.3899,4.204,9.3899,9.3899v27.9279c0,5.1859,4.204,9.3899,9.3899,9.3899h28.2398c5.1859,0,9.3899,4.204,9.3899,9.3899v27.7315c0,5.1859-4.204,9.3899-9.3899,9.3899h-27.8865c-5.1511,0-9.3405-4.1498-9.3895-9.3007l-.2653-27.91c-.049-5.1509-4.2384-9.3007-9.3895-9.3007H9.3899c-5.1859,0-9.3899-4.204-9.3899-9.3899V10.2903C0,5.1044,4.204.9004,9.3899.9004Z",
    fill: "#eaefd7",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Match",
    d: "M336.9512,94.798h-73.552c-4.9784,0-9.0142-4.0359-9.0142-9.0143V9.1772c0-4.9784,4.0359-9.0142,9.0143-9.0142h27.95c4.9784,0,9.0142,4.0358,9.0142,9.0142v30.0036c0,4.9784,4.0358,9.0142,9.0142,9.0142h27.5735c4.9784,0,9.0142,4.0358,9.0142,9.0143v28.5744c0,4.9784-4.0358,9.0142-9.0142,9.0142Z",
    fill: "#eaefd7",
    strokeWidth: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Calendar",
    d: "M188.1457,94.7271h-73.3134c-5.2122,0-9.4376-4.2254-9.4376-9.4376l-.2485-26.7129c0-5.2122,4.2254-9.4376,9.4376-9.4376h27.2328c5.2122,0,9.4376-5.3761,9.4376-10.5884V9.4376c0-5.2122,4.2254-9.4376,9.4376-9.4376h72.9567c5.2122,0,9.4376,4.2254,9.4376,9.4376v28.7288c0,5.2122-4.2254,9.4376-9.4376,9.4376h-26.9543c-5.223,0-9.4528,4.2421-9.4376,9.4651l.3265,28.1929c.0152,5.223-4.2146,9.4651-9.4376,9.4651Z",
    fill: "#eaefd7",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo_white.14eb762d3ac2e4d1fd8679f240e1c975.svg";
export { ForwardRef as ReactComponent };